import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonColor } from '../button/button.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly ButtonColor = ButtonColor;
  protected readonly environment = environment;
}
